import { HIGHWAY, MARKET, TOWN } from './streetscapes';
import type { Route } from './types';

/** DRAFT: stops are a best guess along the Winneba road (N1) into Accra. Please correct. */
export const KASOA_ACCRA: Route = {
  id: 'kasoa-accra',
  name: 'Kasoa ⇄ Accra',
  from: 'Kasoa',
  to: 'Accra (Makola)',
  length: 4400,
  legs: [
    { id: 'kasoa', name: 'Kasoa', subtitle: 'Kasoa Market to Old Barrier', start: 0, end: 900, traffic: 1.2, streetscape: MARKET },
    { id: 'weija', name: 'Weija', subtitle: 'Winneba Road', start: 900, end: 2000, traffic: 1.0, streetscape: HIGHWAY },
    { id: 'mallam', name: 'Mallam', subtitle: 'Mallam Junction', start: 2000, end: 2700, traffic: 1.1, streetscape: TOWN },
    { id: 'kaneshie', name: 'Kaneshie', subtitle: 'First Light to Kaneshie Market', start: 2700, end: 3600, traffic: 1.2, streetscape: MARKET },
    { id: 'circle-makola', name: 'Circle to Makola', subtitle: 'Into Accra Central', start: 3600, end: 4400, traffic: 1.2, streetscape: TOWN },
  ],
  stops: [
    { id: 'kasoa', name: 'Kasoa', at: 160, crowd: [6, 10] },
    { id: 'old-barrier', name: 'Old Barrier', at: 620, crowd: [2, 5] },
    { id: 'weija', name: 'Weija Junction', at: 1100, crowd: [3, 6] },
    { id: 'scc', name: 'SCC', at: 1580, crowd: [2, 5] },
    { id: 'mallam', name: 'Mallam Junction', at: 2080, crowd: [4, 7] },
    { id: 'first-light', name: 'Kaneshie First Light', at: 2560, crowd: [3, 6] },
    { id: 'kaneshie', name: 'Kaneshie Market', at: 3040, crowd: [4, 8] },
    { id: 'circle', name: 'Circle', at: 3620, crowd: [4, 8] },
    { id: 'makola', name: 'Accra (Makola)', at: 4160, crowd: [6, 10] },
  ],
  junctions: [
    { id: 'kasoa', name: 'Kasoa junction', at: 380 },
    { id: 'weija', name: 'Weija junction', at: 860 },
    { id: 'mallam', name: 'Mallam junction', at: 1820 },
    { id: 'kaneshie', name: 'Kaneshie junction', at: 2820 },
    { id: 'circle', name: 'Circle junction', at: 3340 },
    { id: 'makola', name: 'Makola junction', at: 3900 },
  ],
  stations: [
    { id: 'akwaaba-fuel', name: 'Akwaaba Fuel', at: 740 },
    { id: 'black-star-oil', name: 'Black Star Oil', at: 2200 },
    { id: 'weija-oil', name: 'Weija Oil', at: 3740 },
  ],
};
